module.exports = __webpack_public_path__ + "img/Check.bf88bbc3.svg";